import React from 'react';
import { Typography } from '@mui/material';

/**
 * Process text to handle formatting
 * 1. Handle **bold** markdown formatting  
 * 2. Handle \n line breaks
 * 3. Fallback: make "Why It's Important:", "Objective:" bold if no asterisks exist
 */
export const processFormattedText = (text) => {
  if (!text) return '';

  // Check if text contains markdown formatting (asterisks)
  const hasAsterisks = text.includes('**');

  let processedText = text;

  if (hasAsterisks) {
    // Handle markdown formatting
    // Convert **text** to <b>text</b>
    processedText = processedText.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
  } else {
    // Fallback: make specific phrases bold if no asterisks are present
    // This matches the original logic from SkillOne.js
    processedText = processedText.replace("Objective:", `<b>Objective:</b>`)
                                 .replace("Why It's Important:", `<b>Why It's Important:</b>`)
                                 .replace("Objetivo:", `<b>Objetivo:</b>`)
                                 .replace("Por Qué Es Importante:", `<b>Por Qué Es Importante:</b>`)
                                 .replace("¿Por qué es importante?", `<b>¿Por qué es importante?</b>`)
                                 .replace("Por qué es importante", `<b>Por qué es importante</b>`)
                                 .replace("¿Por Qué Es Importante?", `<b>¿Por Qué Es Importante?</b>`);
  }

  // Handle line breaks - convert \n to <br>
  processedText = processedText.replace(/\\n/g, '<br>');
  processedText = processedText.replace(/\n/g, '<br>');

  return processedText;
};

/**
 * React component to render formatted text
 */
export const FormattedTextPreview = ({ text, ...props }) => {
  const formattedText = processFormattedText(text);

  return (
    <Typography
      {...props}
      sx={{ 
        whiteSpace: 'pre-wrap',
        ...props.sx 
      }}
      dangerouslySetInnerHTML={{ __html: formattedText }}
    />
  );
}; 